import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from './config';

interface Usuario {
  nome: string;
  email: string;
  perfil: string;
}

interface AuthContextType {
  usuario: Usuario | null;
  token: string | null;
  login: (email: string, senha: string) => Promise<void>;
  logout: () => void;
  carregando: boolean;
}

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [usuario, setUsuario] = useState<Usuario | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const tokenSalvo = localStorage.getItem('tovis_token');
    const usuarioSalvo = localStorage.getItem('tovis_usuario');
    if (tokenSalvo && usuarioSalvo) {
      setToken(tokenSalvo);
      setUsuario(JSON.parse(usuarioSalvo));
    }
    setCarregando(false);
  }, []);

  const login = async (email: string, senha: string) => {
    const formData = new URLSearchParams();
    formData.append('username', email);
    formData.append('password', senha);
    const resp = await axios.post(`${API_URL}/auth/login`, formData);
    const { access_token, usuario } = resp.data;
    setToken(access_token);
    setUsuario(usuario);
    localStorage.setItem('tovis_token', access_token);
    localStorage.setItem('tovis_usuario', JSON.stringify(usuario));
  };

  const logout = () => {
    setToken(null);
    setUsuario(null);
    localStorage.removeItem('tovis_token');
    localStorage.removeItem('tovis_usuario');
  };

  return (
    <AuthContext.Provider value={{ usuario, token, login, logout, carregando }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
